// Read snapshots are disposable; unsaved work belongs in a separate store.
export class BoundedCache extends Map {
  constructor(limit = 20) { super(); this.limit = limit; }
  get(key) {
    if (!super.has(key)) return undefined;
    const value = super.get(key);
    super.delete(key); super.set(key, value);
    return value;
  }
  set(key, value) {
    super.delete(key); super.set(key, value);
    while (this.size > this.limit) super.delete(this.keys().next().value);
    return this;
  }
}

export class BoundedSet extends Set {
  constructor(limit = 20) { super(); this.limit = limit; }
  add(value) {
    super.delete(value); super.add(value);
    while (this.size > this.limit) super.delete(this.values().next().value);
    return this;
  }
}
